<template>
    <br/>
    <br/>
    <br/>
    <h1>404 Not Found</h1>
    <br/>
    <br/>
    <br/>
</template>

<script>
export default {
    metaInfo: {
        title: 'Green Solutions | 404'
    }
}
</script>